var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dashboard", attrs: { id: "container" } }, [
    _c(
      "div",
      { attrs: { id: "gridContainer" } },
      [
        _c(
          "v-card",
          { staticClass: "v-flex", staticStyle: { width: "100%" } },
          [
            _c("i", {
              staticClass: "material-icons",
              staticStyle: {
                width: "24px",
                height: "24px",
                "margin-top": "4%",
                "border-radius": "50%",
                background: "rgb(42, 255, 78)"
              },
              attrs: { title: "En Línea" }
            }),
            _c(
              "p",
              {
                staticStyle: {
                  color: "#4f4f4f",
                  position: "absolute",
                  "margin-top": "0%",
                  "margin-left": "3%"
                }
              },
              [_vm._v("\n        " + _vm._s(_vm.message) + "\n      ")]
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }